import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MediaMatcherService {
  public readonly isSmallScreen$ = new BehaviorSubject<boolean>(false);
}
